var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { StringWidget } from '../string.widget';
var DurationDaysWidget = (function (_super) {
    __extends(DurationDaysWidget, _super);
    function DurationDaysWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._value = '';
        return _this;
    }
    Object.defineProperty(DurationDaysWidget.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    DurationDaysWidget.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.formProperty.valueChanges.subscribe(function (newValue) {
            if (_this.control.value !== newValue) {
                _this._value = newValue ? _this.calc(newValue) : '';
            }
        });
    };
    DurationDaysWidget.prototype.calc = function (totalDays) {
        if (totalDays <= 0)
            return '';
        var weeks = Math.floor(totalDays / 7);
        var days = totalDays - (weeks * 7);
        var weeksString = weeks > 0 ? weeks + " " + this._n(weeks, 'week', 'weeks') : '';
        var daysString = days > 0 ? days + " " + this._n(days, 'day', 'days') : '';
        return [weeksString, daysString].filter(String).join(' + ');
    };
    DurationDaysWidget.prototype._n = function (n, singular, plural) {
        return Math.abs(n) === 1 ? singular : plural;
    };
    return DurationDaysWidget;
}(StringWidget));
export { DurationDaysWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/custom/durationdays.widget.ts.pre-build-optimizer.js